import React from 'react'
import { Plugins } from '@leverege/plugin'

export default Plugins.createFactory( 'TranslationEditor', {
  strategy : Plugins.reactStrategy( React, 'value' ),
  pluginKey : 'editor'
} )
